var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BrokerDisclaimer"},[_c('MobileNav',{attrs:{"page_title":_vm.nav_title}}),_c('div',{staticStyle:{"margin-top":"40px"}},[_c('BrokerDisclaimerComponent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }